import { useTranslation } from "react-i18next";
import {
  getNotificationDisplayTitle,
  getNotificationPlainText,
} from "@/lib/notifications/notificationContent";
import {
  NotificationActionButton,
  NotificationSurface,
} from "@/components/common/Notifications/NotificationPresentation";
import { Done, OpenInNew } from "@/components/common/Icons/Icons";

export function ActionToastContent({
  message,
  showClose,
  dismiss,
  variant,
}) {
  const { t } = useTranslation();

  return (
    <NotificationSurface
      severity={variant}
      body={t(message)}
      closeLabel={t("components.actions.close")}
      onClose={showClose ? dismiss : undefined}
      role={variant === "error" ? "alert" : "status"}
      verticallyCentered
    />
  );
}

export function RealtimeNotificationToastContent({
  notification,
  showClose,
  dismiss,
  onAction,
  onMarkRead,
}) {
  const { t } = useTranslation();
  const hasAction =
    notification?.action?.kind === "toolCommand" && typeof onAction === "function";
  const unread = !notification?.readAtUtc;
  const body = getNotificationPlainText(notification, t);

  return (
    <NotificationSurface
      severity={notification?.severity}
      category={notification?.category}
      title={getNotificationDisplayTitle(notification, t)}
      body={body ? <span className="line-clamp-3">{body}</span> : null}
      source={notification?.source}
      unread={unread}
      closeLabel={t("components.actions.close")}
      onClose={showClose ? dismiss : undefined}
    >
      {unread && typeof onMarkRead === "function" && (
        <NotificationActionButton
          icon={Done}
          onClick={() => {
            onMarkRead(notification);
            dismiss();
          }}
        >
          {t("components.notifications.actions.mark_read")}
        </NotificationActionButton>
      )}
      {hasAction && (
        <NotificationActionButton
          icon={OpenInNew}
          onClick={() => {
            onAction(notification);
            dismiss();
          }}
        >
          {t("components.notifications.actions.open")}
        </NotificationActionButton>
      )}
    </NotificationSurface>
  );
}
